document.addEventListener("DOMContentLoaded", () => {
    async function copyTargetText(e, hasCode) {
        try {
            if (hasCode) {
                const textCode = e.target.parentNode.previousElementSibling.textContent
                if (textCode) {
                    const codeValue = textCode.split(":")[1]
                    await navigator.clipboard.writeText(codeValue)
                }
            }
        } catch (err) {
            console.error("Failed to copy: ", err)
        }
    }

    const pageTeaser = document.querySelector(".insight-page-teaser")
    const cardSlider = document.querySelector(".partner-slider")
    const cardSliderMobile = document.querySelector(".partner-slider--mobile")
    const partnerCards = document.querySelectorAll(".partner-card")
    const messages = document.querySelectorAll(".partner-card__message")
    const goButtons = document.querySelectorAll(".cta:not(.cta--copy)")

    partnerCards.forEach((item) => {
        if (item.hasAttribute("handled")) {
            return
        }
        item.setAttribute("handled", "true")

        item.addEventListener("click", (e) => {
            if (e.target.classList.contains("insight-card__title")) {
                return
            }

            if (e.target.classList.contains("cta--copy")) {
                return
            }

            const title = item.querySelector(".insight-card__title")

            title?.click()
        })
    })

    goButtons.forEach((button) => {
        button.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                const title = e.target.parentNode.closest(".partner-card").querySelector(".insight-card__title")
                title?.click()
            }
        })
    })

    const onCopyPromoCode = (e) => {
        const copyLink = e.target.closest(".insight-card__cta .cta--copy")

        if (copyLink) {
            e.stopPropagation()
            e.preventDefault()
            const hasCode = e.target.parentNode.previousElementSibling.classList.contains("partner-card__code")
            copyTargetText(e, hasCode)

            if (partnerCards) {
                partnerCards.forEach((item) => {
                    const partnerCode = item.querySelector(".partner-card__code")

                    if (partnerCode) {
                        partnerCode.classList.remove("hidden")
                    }

                    const link = item.querySelector(".insight-card__cta .cta--copy")

                    if (item.contains(copyLink)) {
                        item.classList.add("active")
                        if (link) {
                            link.classList.add("hidden")
                            link.nextElementSibling ? link.nextElementSibling.classList.add("visible") : null
                        }
                    } else {
                        item.classList.remove("active")
                        if (link) {
                            link.classList.remove("hidden")
                            link.nextElementSibling ? link.nextElementSibling.classList.remove("visible") : null
                        }
                    }

                    if (messages) {
                        messages.forEach((message) => {
                            message.classList.remove("visible")
                        })
                    }
                })
            }

            if (hasCode) {
                const currentCode = e.target.parentNode.previousElementSibling

                if (currentCode) {
                    if (currentCode.previousElementSibling.classList.contains("partner-card__message")) {
                        currentCode.classList.add("hidden")
                        currentCode.previousElementSibling.classList.add("visible")
                    }
                }
            }

            setTimeout(() => {
                const goButton = e.target.parentNode.querySelector(".cta--go")

                goButton?.focus()
            }, 50)
        }
    }

    function addListener(node) {
        node.addEventListener("click", (e) => {
            onCopyPromoCode(e)
        })

        node.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                onCopyPromoCode(e)
            }
        })
    }

    pageTeaser ? addListener(pageTeaser) : null
    cardSlider ? addListener(cardSlider) : null
    cardSliderMobile ? addListener(cardSliderMobile) : null
})
